import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { rootRoute } from './__root';
import { requireGuest } from '@/lib/route-guards';

const loginSearchSchema = z.object({
  inviteToken: z.string().optional(),
  shareableLinkToken: z.string().optional(),
  error: z.string().optional(),
  // `redirect` (legacy) and `next` (set by the protected-route guard) both
  // carry the post-login destination. LoginPage reads `redirect`; the guard
  // emits `next` so we accept both and they coexist non-destructively.
  redirect: z.string().optional(),
  next: z.string().optional(),
});

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  validateSearch: loginSearchSchema,
  beforeLoad: requireGuest,
  component: lazyRouteComponent(
    () => import('@/features/auth/LoginPage'),
    'LoginPage',
  ),
});
